import { base64ToArrayBuffer, getDataType, isoToStd } from './utils';

class Minutia {
  constructor(x, y, direction, type, triangle) {
    this.x = x;
    this.y = y;
    this.direction = direction;
    this.triangle = triangle;
    this.type = type;
  }
}
class STDMinutia {
  constructor(x, y, ang, val, type) {
    this.x = x;
    this.y = y;
    this.ang = ang;
    this.val = val;
    this.type = type;
  }
}
class Feature {
  constructor() {
    this.minutiaNum = 0;
    this.minutiaArr = [];
  }
}
class STDTPHeader {
  constructor() {
    this.count = 0;
    this.val = 0;
    this.imgx = 0;
    this.imgy = 0;
    this.resx = 0;
    this.resy = 0;
    this.center = 0;
  }
}
class MatchResult {
  constructor() {
    this.similarity = 0;
    this.rotation = 0;
    this.transX = 0;
    this.transY = 0;
    this.MMCount = 0;
  }
}
const VF_MINUTIA_CORE = 3;
const VF_MATCHMODE_VERIFY = 1;
const VF_MATCHMODE_IDENTIFY = 2;
const MAX_MINUTIA_NUM = 60;
const PI = Math.PI;
const EPI = 57.29578;

const DisTbl = [
  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [1, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  [2, 2, 2, 3, 4, 5, 6, 7, 8, 9],
  [3, 3, 3, 4, 5, 5, 6, 7, 8, 9],
  [4, 4, 4, 5, 5, 6, 7, 8, 8, 9],
  [5, 5, 5, 5, 6, 7, 7, 8, 9, 10],
  [6, 6, 6, 6, 7, 7, 8, 9, 10, 10],
  [7, 7, 7, 7, 8, 8, 9, 9, 10, 11],
  [8, 8, 8, 8, 8, 9, 10, 10, 11, 12],
  [9, 9, 9, 9, 9, 10, 10, 11, 12, 12],
];

function getAngleDis(angleBegin, angleEnd) {
  let a = angleEnd - angleBegin;
  if (a < 0) {
    a += 360;
  }
  return a;
}

function angleAbs360(angle1, angle2) {
  let a = Math.abs(angle1 - angle2);
  return a > 180 ? 360 - a : a;
}

function align(feature, featureCore, rotation, transX, transY) {
  const alignedFeature = new Feature();
  const rad = rotation / EPI;
  const sinV = Math.sin(rad);
  const cosV = Math.cos(rad);
  const cx = featureCore.x;
  const cy = featureCore.y;
  alignedFeature.minutiaNum = feature.minutiaNum;
  alignedFeature.minutiaArr = feature.minutiaArr.map((minutia) => {
    const x = Math.floor(
      cx + cosV * (minutia.x - cx) - sinV * (minutia.y - cy) + transX + 0.5,
    );
    const y = Math.floor(
      cy + sinV * (minutia.x - cx) + cosV * (minutia.y - cy) + transY + 0.5,
    );
    return new Minutia(
      x,
      y,
      (minutia.direction + rotation) % 360,
      minutia.type,
    );
  });
  return alignedFeature;
}
// export function checkTemplate(pFeature) {
//   if (pFeature[0] !== 3) {
//     return -1; // Check format identifier, assuming '3' is a valid format identifier.
//   }

//   const minutiaeCount = pFeature[3];
//   if (minutiaeCount > 50 || minutiaeCount <= 0) {
//     return -1; // Check if the count of minutiae is within a realistic range.
//   }

//   let isValid = true;
//   let offset = 56; // Assuming the minutiae data starts at offset 56.
//   for (let i = 0; i < minutiaeCount; i++) {
//     const baseIdx = offset + i * 4;
//     const info =
//       (pFeature[baseIdx] << 24) |
//       (pFeature[baseIdx + 1] << 16) |
//       (pFeature[baseIdx + 2] << 8) |
//       pFeature[baseIdx + 3];

//     const x = info >> 23;
//     const y = (info >> 14) & 0x01ff;
//     const ang = (info >> 5) & 0x01ff;

//     if (x >= 256 || y >= 288 || ang >= 360) {
//       isValid = false;
//       break; // Validate each minutia's properties.
//     }
//   }

//   return isValid ? 0 : -1;
// }

function alignMatch(alignFeature, template, matchMode) {
  let flagA = new Array(MAX_MINUTIA_NUM).fill(0);
  let flagT = new Array(MAX_MINUTIA_NUM).fill(0);
  let score = 0;
  let matchNum = 0;
  const matchResult = new MatchResult();

  if (!alignFeature.minutiaArr.length || !template.minutiaArr.length) {
    matchResult.similarity = 0;
    return matchResult;
  }

  template.minutiaArr.forEach((minT, i) => {
    if (!flagT[i]) {
      alignFeature.minutiaArr.forEach((minA, j) => {
        if (!flagA[j] && minT.type === minA.type) {
          let angle = angleAbs360(minT.direction, minA.direction);
          if (angle < 10) {
            let x1 = minT.x,
              y1 = minT.y,
              x2 = minA.x,
              y2 = minA.y;
            if (Math.abs(x1 - x2) < 10 && Math.abs(y1 - y2) < 10) {
              let dis = DisTbl[Math.abs(y1 - y2)][Math.abs(x1 - x2)];
              if (dis < 10) {
                flagA[j] = 1;
                flagT[i] = 1;
                score += 10 - angle + (10 - dis);
                matchNum++;
              }
            }
          }
        }
      });
    }
  });

  matchResult.MMCount = matchNum;
  matchResult.similarity =
    (4 * score * matchNum * MAX_MINUTIA_NUM) /
    Math.pow(template.minutiaNum + alignFeature.minutiaNum, 2);
  if (matchMode === VF_MATCHMODE_IDENTIFY && matchNum >= 8) {
    matchResult.similarity = Math.min(matchResult.similarity, 100);
    return matchResult;
  }
  return matchResult;
}

function globalMatch(feature, template, matchMode) {
  let alignMax = new MatchResult();
  template.minutiaArr.forEach((minT, n) => {
    feature.minutiaArr.forEach((minF, m) => {
      if (minF.type === minT.type) {
        let rotation = getAngleDis(minF.direction, minT.direction);
        let transX = minT.x - minF.x;
        let transY = minT.y - minF.y;

        const alignedFeature = align(
          feature,
          feature.minutiaArr[m],
          rotation,
          transX,
          transY,
        );
        let tempResult = alignMatch(alignedFeature, template, matchMode);
        if (tempResult.similarity > alignMax.similarity) {
          alignMax = tempResult;
          alignMax.rotation = rotation;
          alignMax.transX = transX;
          alignMax.transY = transY;
        }
      }
    });
  });
  return alignMax;
}

function verify(feature, template, matchMode) {
  const matchResult = globalMatch(feature, template, matchMode);
  if (matchMode !== VF_MATCHMODE_IDENTIFY && matchResult.MMCount < 15) {
    matchResult.similarity = Math.round(
      matchResult.similarity * Math.sin((matchResult.MMCount * PI) / 30),
    );
  }
  return matchResult;
}

function getStdTpInfo(pData) {
  let stdTpHeader = new STDTPHeader();
  let stdMinutiaes = new Array(100).fill(null).map(() => new STDMinutia());
  let stdCenters = new Array(5).fill(null).map(() => new STDMinutia());
  stdTpHeader.count = pData[3];
  stdTpHeader.val = pData[2];
  stdTpHeader.imgx = 256;
  stdTpHeader.imgy = 288;
  stdTpHeader.resx = 500;
  stdTpHeader.resy = 500;
  stdTpHeader.center = 0;

  for (let i = 0; i < pData[3]; i++) {
    const info =
      (pData[56 + i * 4] << 24) +
      (pData[56 + i * 4 + 1] << 16) +
      (pData[56 + i * 4 + 2] << 8) +
      pData[56 + i * 4 + 3];
    const x = info >> 23;
    const y = (info >> 14) & 0x01ff;
    const ang = (info >> 5) & 0x01ff;
    const b = (info >> 1) & 0x0f;
    const s = info & 0x01;

    stdMinutiaes[i] = new STDMinutia(x, y, ang, b, s);
  }

  if (pData[40] * 2 > 0) {
    stdCenters[stdTpHeader.center] = new STDMinutia(
      pData[40] * 2,
      pData[41] * 2,
      0,
      0,
      2,
    );
    stdTpHeader.center++;
  }
  if (pData[42] * 2 > 0) {
    stdCenters[stdTpHeader.center] = new STDMinutia(
      pData[40] * 2,
      pData[41] * 2,
      0,
      0,
      2,
    );
    stdTpHeader.center++;
  }
  return { stdTpHeader, stdMinutiaes };
}

function decodeSyFeature(lpData) {
  const feature = new Feature();
  const { stdTpHeader, stdMinutiaes } = getStdTpInfo(lpData);

  feature.minutiaNum = stdTpHeader.count + stdTpHeader.center;
  for (let i = 0; i < stdTpHeader.center; i++) {
    feature.minutiaArr.push(
      new Minutia(stdMinutiaes[i].x, stdMinutiaes[i].y, 0, VF_MINUTIA_CORE),
    );
  }
  let j = 0;
  for (
    let i = stdTpHeader.center;
    i < stdTpHeader.count + stdTpHeader.center;
    i++
  ) {
    feature.minutiaArr.push(
      new Minutia(
        stdMinutiaes[j].x,
        stdMinutiaes[j].y,
        stdMinutiaes[j].ang,
        stdMinutiaes[j].type,
      ),
    );
    j++;
  }

  return feature;
}

function matchFP(feature1Data, feature2Data) {
  let feature1 = decodeSyFeature(feature1Data);
  let feature2 = decodeSyFeature(feature2Data);
  const matchResult = verify(feature1, feature2, VF_MATCHMODE_VERIFY);

  if (matchResult.MMCount < 8) {
    return 0;
  } else {
    return matchResult.similarity;
  }
}

function matchTemplate(lpref, refsize, lpmat, matsize) {
  let n = refsize / 256;
  let score = 0;

  for (let i = 0; i < n; i++) {
    score += matchFP(lpref.slice(i * 256, (i + 1) * 256), lpmat);
  }

  return score / 2;
}

export const matchTemplates = (template1Str, template2Str) => {
  if (!template1Str || !template2Str) {
    return;
  }

  const template1 = base64ToArrayBuffer(template1Str);
  const template2 = base64ToArrayBuffer(template2Str);

  if (
    !template1 ||
    !template2 ||
    template1.length === 0 ||
    template2.length === 0
  ) {
    return;
  }

  // Assuming 512 is the size needed for each template after processing
  let processedTemplate1 = new Uint8Array(512).fill(0);
  let processedTemplate2 = new Uint8Array(512).fill(0);

  // Check and convert data types
  if (getDataType(template1) === 1) {
    processedTemplate1.set(template1.slice(0, 512));
  } else {
    processedTemplate1 = isoToStd(2, template1);
  }

  if (getDataType(template2) === 1) {
    processedTemplate2.set(template2.slice(0, 512));
  } else {
    processedTemplate2 = isoToStd(2, template2);
  }

  // Match the templates
  let score = matchTemplate(processedTemplate1, 256, processedTemplate2, 256);
  console.log(`Match Score: ${score}`);
  return score;
};
